import { Grid } from "@material-ui/core";
import React, { useContext } from "react";
import AccordionNav from "../../components/common/AccordionNav";
import UserContext from "../../context/user-context";
import { useTranslation } from "../../hooks/useTranslation";
import { EntryType } from "../../passapp-sdk/models/EntryMethod";
import { userSetVehicleType } from "../../store/actions/userAction";
import { entryMethods } from "../../utils/Items";
import { EntrantTabIndex } from "../../utils/tabIndex";
import Bicycle from "./Bicycle/Bicycle";
import EntryMethod from "./EntryMethod/EntryMethod";
import Vehicle from "./Vehicle/Vehicle";

const EntryMethods = () => {
  const { state, dispatch } = useContext(UserContext);
  const { t, BundleKey } = useTranslation();

  const onSelected = (value: string) => {
    if (state.vehicleType === value) return;
    dispatch(userSetVehicleType(value));
  };

  return (
    <AccordionNav
      title={
        state.config?.eventType === "in"
          ? t(BundleKey.DETAIL_ENTRYMETHOD_TITLE)
          : t(BundleKey.DETAIL_ENTRYMETHOD_TITLE_EXIT)
      }
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid
            container
            direction="row"
            justifyContent="space-evenly"
            alignItems="center"
          >
            {entryMethods.map((mean, index) => {
              return (
                <Grid key={index} item>
                  <EntryMethod
                    title={t(mean.bundleName)}
                    id={mean.id}
                    iconUrl={mean.iconUrl}
                    action={null}
                    tabIndex={EntrantTabIndex.entryMethodBike}
                    select={state.vehicleType}
                    onSelected={onSelected}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid
            container
            direction="row"
            justifyContent="space-evenly"
            alignItems="center"
          >
            {state.vehicleType === EntryType.CAR ? (
              <Grid item xs={12}>
                <Vehicle />
              </Grid>
            ) : state.vehicleType === EntryType.BICYCLE ? (
              <Grid item xs={6}>
                <Bicycle />
              </Grid>
            ) : null}
          </Grid>
        </Grid>
      </Grid>
    </AccordionNav>
  );
};

export default EntryMethods;
